import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import HeaderImage from "../assets/img/Claradécor_header.webp";
import Trame from "../assets/img/TrameFine.webp";
import Profile from "../assets/img/Clara_Photo_CD.webp";
import ServicePromesse from "../assets/img/Services_Promesse.webp";
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet-async";

export default function Home() {
  return (
    <div className="home">
      <Helmet>
        <title>Clara Décor — Peinture & décoration à Vannes (Morbihan)</title>
        <meta
          name="description"
          content="Clara Décor, peintre décoratrice (Morbihan). Peinture intérieure & extérieure, ravalement, enduits décoratifs, revêtements muraux et sols. Accompagnement sur-mesure et finitions raffinées."
        />
        <link rel="canonical" href="https://claradecor.fr/" />
        <meta
          property="og:title"
          content="Clara Décor, peinture et décoration à Vannes"
        />
        <meta
          property="og:description"
          content="Peinture intérieure et extérieure, ravalement, enduits décoratifs et revêtements. Clara Décor sublime vos espaces à Vannes et dans le Morbihan."
        />
        <meta property="og:url" content="https://claradecor.fr/" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://claradecor.fr/images/og-home.jpg"
        />
        <meta property="og:locale" content="fr_FR" />
        <meta name="twitter:card" content="summary_large_image" />
        <script type="application/ld+json">
          {`
    {
      "@context": "https://schema.org",
      "@type": "HomeAndConstructionBusiness",
      "name": "Clara Décor",
      "description": "Peintre et décoratrice à Vannes (Morbihan). Peinture intérieure et extérieure, ravalement, enduits décoratifs, revêtements muraux et sols. Accompagnement sur-mesure et finitions raffinées.",
      "url": "https://claradecor.fr/",
      "image": "https://claradecor.fr/images/og-home.jpg",
      "telephone": "+33-6-74-81-00-15",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Vannes",
        "addressRegion": "Bretagne",
        "postalCode": "56000",
        "addressCountry": "FR"
      },
      "areaServed": "Morbihan",
      "sameAs": [
        "https://www.instagram.com/claradecor",
      ]
    }
    `}
        </script>
      </Helmet>

      <Navbar />
      <header>
        <div className="header-left">
          <h1>
            <img src={HeaderImage} alt="Logo de Clara Décors" />
          </h1>
          <p>
            Forte de 10 ans d'expériences dans la décoration et la peinture, je
            mets mon expertise au service de vos projets. Un savoir-faire acquis
            au fil des années, entre passion, technique et sens du détail.
          </p>
          <div className="header-btn">
            <button
              className="btn-primary"
              onClick={() => {
                const el = document.getElementById("home-about");
                if (el) {
                  el.scrollIntoView({ behavior: "smooth" });
                }
              }}
              type="button"
            >
              Découvrir{" "}
              <span className="arrow">
                <FaArrowRight />
              </span>
            </button>
            <Link to={"/contact"} className="btn-secondary">
              Prendre contact
            </Link>
          </div>
        </div>
      </header>
      <body>
        <img src={Trame} className="trame" alt="image de trame Clara Décors" />
        <div className="home-about-header" id="home-about">
          <h2>À propos de moi</h2>
          <p>
            Passionnée par la couleur, les matières et le{" "}
            <span className="color1">travail bien fait</span>, je mets plus de{" "}
            <span className="color1">10 ans d'expérience</span> au service de
            vos projets de peinture et de décoration.
          </p>
        </div>
        <div className="home-about-container">
          <div className="home-about-left">
            <img src={Profile} className="home-about-image" alt="Clara Petit" />
            <h3>
              Clara <br /> Petit
            </h3>
            <p className="color1 peinture-deco">Peinture & décoration</p>
            <p>
              Artisane indépendante, je vous accompagne avec{" "}
              <span className="color1">attention et exigence</span> du premier
              échange aux finitions
            </p>

            <p>
              Mon objectif :{" "}
              <span className="color1">sublimer vos espaces</span> en respectant
              vos envies, votre mode de vie et l'identité du lieu.
            </p>
            <button
              className="btn-primary"
              onClick={() => {
                const el = document.getElementById("home-services");
                if (el) {
                  el.scrollIntoView({ behavior: "smooth" });
                }
              }}
              type="button"
            >
              Mes services{" "}
              <span className="arrow">
                <FaArrowRight />
              </span>
            </button>
          </div>
          <div className="home-about-right">
            <img src={Profile} alt="Clara Petit" />
          </div>
        </div>

        <div className="home-services" id="home-services">
          <div className="home-services-header">
            <h2>Mes services</h2>
            <p>
              Forte de plus de{" "}
              <span className="color1">10 ans d'expérience</span>, je vous
              accompagne dans tous vos projets de peinture et de décoration avec
              un <span className="color1">service personnalisé</span> et un
              soucis du détail à chaque étape.
            </p>
          </div>
          <div className="home-services-content">
            <div className="home-services-cards">
              <div className="home-services-card-1">
                <h3>Peinture</h3>
              </div>
              <div className="home-services-card-2">
                <h3 className="color1">-- Peinture & Décoration --</h3>
                <Link
                  to={"/services"}
                  className="btn-tertiary btn-home-services"
                >
                  Peinture
                </Link>
                <Link
                  to={"/services"}
                  className="btn-tertiary btn-home-services"
                >
                  Revêtements muraux & sols
                </Link>
                <Link
                  to={"/services"}
                  className="btn-tertiary btn-home-services"
                >
                  Enduits décoratifs
                </Link>
                <Link
                  to={"/services"}
                  className="btn-tertiary btn-home-services"
                >
                  Décoration
                </Link>
                <Link
                  to={"/services"}
                  className="btn-tertiary btn-home-services"
                >
                  Traitement et ravalement de façade
                </Link>
              </div>
              <div className="home-services-card-3">
                <h3>Décoration</h3>
              </div>
            </div>
          </div>
          <div className="home-services-footer">
            <Link to={"/realisations"} className="btn-primary">
              Mes réalisations
              <span className="arrow">
                <FaArrowRight />
              </span>
            </Link>
            <Link to={"/services"} className="btn-secondary">
              Mes services
            </Link>
          </div>
        </div>
        <div className="home-promesse">
          <div className="home-promesse-left">
            <h2>Ma promesse</h2>
            <h3 className="color1">Un travail soigné & à votre écoute</h3>
            <p>
              Je m'engage à fournir un service de qualité, en respectant vos
              besoins et vos attentes. Chaque projet est unique et mérite une
              attention particulière. Je suis à votre écoute pour vous
              conseiller et vous accompagner tout au long de votre projet.
            </p>
          </div>
          <div className="home-promesse-right">
            <img src={ServicePromesse} alt="Ma promesse" />
          </div>
        </div>
        <div className="suggestions">
          <h2>Des questions ?</h2>
          <p className="suggestions-text">
            Il est normal d'avoir des{" "}
            <span className="color1">interrogations spécifiques.</span> Si vous
            ne trouvez pas réponse à vos questions, n'hésitez pas à me contacter
            via le formulaire dédié, je vous répondrais dans les plus brefs
            délais, avec toute l'attention que mérite{" "}
            <span className="color1">votre projet.</span>
          </p>
          <Link to={"/contact"} className="btn-secondary">
            Prendre contact
          </Link>
        </div>
        <div className="prefooter"></div>
      </body>
      <Footer />
    </div>
  );
}
